import { type App, defineAsyncComponent } from 'vue'

const components = {
  BrandSetupSteps: defineAsyncComponent(() => import('./BrandSetupSteps.vue')),
  SetupHeader: defineAsyncComponent(() => import('./SetupHeader.vue')),
  SetupPage: defineAsyncComponent(() => import('../pages/SetupPage.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
